import { ConfigurationItem } from "constants/configurations";

export enum ConfigurationFeature {
  ALL,
  ARROBA_BALANCE,
  BIRTH,
  CONCILIATION,
  CONSUMPTION_CLOSURE,
  CREEP_FEEDING,
  DEATH,
  DRUM,
  ENTRIES_AND_EXITS,
  FARM_GOALS,
  HERD_EVOLUTION_AND_NUTRITION_PLAN,
}

export function getConfigurationCardIcon(id: ConfigurationItem): string {
  const itemToPathMap: Record<ConfigurationItem, string> = {
    [ConfigurationItem.ANIMAL_CATEGORY]: "ico-categoria-animal.svg",
    [ConfigurationItem.CAUSE_OF_DEATH]: "ico-causa-morte.svg",
    [ConfigurationItem.CORRAL_LISTING]: "ico-listagem-currais.svg",
    [ConfigurationItem.FARM_GOALS]: "ico-metas-fazenda.svg",
    [ConfigurationItem.FORMULATIONS]: "ico-formulacao.svg",
    [ConfigurationItem.HERD_EVOLUTION_AND_NUTRITION_PLAN]:
      "ico-evolucao-pan.svg",
    [ConfigurationItem.INGREDIENTS]: "ico-ingrediente.svg",
    [ConfigurationItem.LOT_GOALS]: "ico-objetivo-lote.svg",
    [ConfigurationItem.PLOT_LISTING]: "ico-listagem-lote.svg",
    [ConfigurationItem.RAIN_HISTORY]: "ico-historico-chuva.svg",
    [ConfigurationItem.SCORE_ADJUSTMENT]: "ico-ajuste-score.svg",
    [ConfigurationItem.WEIGHING_BY_CATEGORY]: "ico-pesagem.svg",
    [ConfigurationItem.WEIGHT_GAIN_CURVE]: "ico-ganho-peso.svg",
  };

  const path = itemToPathMap[id];

  return path != null ? `../images/${path}` : "";
}

export const NEW_BADGE_ICON_PATH = "../images/ico-novo.svg";
